/* eslint max-nested-callbacks: ["error", 5] */
'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _asyncIterator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var sanitize = require('sanitize-filename');

var mergeOptions = require('merge-options');

var crypto = require('libp2p-crypto');

var DS = require('interface-datastore');

var CMS = require('./cms');

var errcode = require('err-code');

var keyPrefix = '/pkcs8/';
var infoPrefix = '/info/'; // NIST SP 800-132

var NIST = {
  minKeyLength: 112 / 8,
  minSaltLength: 128 / 8,
  minIterationCount: 1000
};
var defaultOptions = {
  // See https://cryptosense.com/parametesr-choice-for-pbkdf2/
  dek: {
    keyLength: 512 / 8,
    iterationCount: 10000,
    salt: 'you should override this value with a crypto secure random number',
    hash: 'sha2-512'
  }
};

function validateKeyName(name) {
  if (!name) return false;
  if (typeof name !== 'string') return false;
  return name === sanitize(name.trim());
}
/**
 * Throws an error after a delay
 *
 * This assumes than an error indicates that the keychain is under attack. Delay returning an
 * error to make brute force attacks harder.
 *
 * @param {string | Error} err - The error
 * @private
 */


function throwDelayed(_x) {
  return _throwDelayed.apply(this, arguments);
}
/**
 * Converts a key name into a datastore name.
 *
 * @param {string} name
 * @returns {DS.Key}
 * @private
 */


function _throwDelayed() {
  _throwDelayed = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(err) {
    var min, max, delay;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            min = 200;
            max = 1000;
            delay = Math.random() * (max - min) + min;
            _context11.next = 5;
            return new Promise(function (resolve) {
              return setTimeout(resolve, delay);
            });

          case 5:
            throw err;

          case 6:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));
  return _throwDelayed.apply(this, arguments);
}

function DsName(name) {
  return new DS.Key(keyPrefix + name);
}
/**
 * Converts a key name into a datastore info name.
 *
 * @param {string} name
 * @returns {DS.Key}
 * @private
 */


function DsInfoName(name) {
  return new DS.Key(infoPrefix + name);
}
/**
 * Information about a key.
 *
 * @typedef {Object} KeyInfo
 *
 * @property {string} id - The universally unique key id.
 * @property {string} name - The local key name.
 */

/**
 * Manages the lifecycle of a key. Keys are encrypted at rest using PKCS #8.
 *
 * A key in the store has two entries
 * - '/info/*key-name*', contains the KeyInfo for the key
 * - '/pkcs8/*key-name*', contains the PKCS #8 for the key
 *
 */


var Keychain = /*#__PURE__*/function () {
  /**
   * Creates a new instance of a key chain.
   *
   * @param {DS} store - where the key are.
   * @param {object} options - ???
   */
  function Keychain(store, options) {
    _classCallCheck(this, Keychain);

    if (!store) {
      throw new Error('store is required');
    }

    this.store = store;
    var opts = mergeOptions(defaultOptions, options); // Enforce NIST SP 800-132

    if (!opts.passPhrase || opts.passPhrase.length < 20) {
      throw new Error('passPhrase must be least 20 characters');
    }

    if (opts.dek.keyLength < NIST.minKeyLength) {
      throw new Error("dek.keyLength must be least ".concat(NIST.minKeyLength, " bytes"));
    }

    if (opts.dek.salt.length < NIST.minSaltLength) {
      throw new Error("dek.saltLength must be least ".concat(NIST.minSaltLength, " bytes"));
    }

    if (opts.dek.iterationCount < NIST.minIterationCount) {
      throw new Error("dek.iterationCount must be least ".concat(NIST.minIterationCount));
    } // Create the derived encrypting key


    var dek = crypto.pbkdf2(opts.passPhrase, opts.dek.salt, opts.dek.iterationCount, opts.dek.keyLength, opts.dek.hash);
    Object.defineProperty(this, '_', {
      value: function value() {
        return dek;
      }
    });
  }
  /**
   * Gets an object that can encrypt/decrypt protected data
   * using the Cryptographic Message Syntax (CMS).
   *
   * CMS describes an encapsulation syntax for data protection. It
   * is used to digitally sign, digest, authenticate, or encrypt
   * arbitrary message content.
   *
   * @returns {CMS}
   */


  _createClass(Keychain, [{
    key: "createKey",

    /**
     * Create a new key.
     *
     * @param {string} name - The local key name; cannot already exist.
     * @param {string} type - One of the key types; 'rsa'.
     * @param {int} size - The key size in bits.
      * @returns {KeyInfo}
     */
    value: function () {
      var _createKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(name, type, size) {
        var self, dsname, exists, keyInfo, keypair, kid, pem, batch;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                self = this;

                if (!(!validateKeyName(name) || name === 'self')) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", throwDelayed(errcode(new Error("Invalid key name '".concat(name, "'")), 'ERR_INVALID_KEY_NAME')));

              case 3:
                if (!(typeof type !== 'string')) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", throwDelayed(errcode(new Error("Invalid key type '".concat(type, "'")), 'ERR_INVALID_KEY_TYPE')));

              case 5:
                if (Number.isSafeInteger(size)) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return", throwDelayed(errcode(new Error("Invalid key size '".concat(size, "'")), 'ERR_INVALID_KEY_SIZE')));

              case 7:
                dsname = DsName(name);
                _context.next = 10;
                return self.store.has(dsname);

              case 10:
                exists = _context.sent;

                if (!exists) {
                  _context.next = 13;
                  break;
                }

                return _context.abrupt("return", throwDelayed(errcode(new Error("Key '".concat(name, "' already exists")), 'ERR_KEY_ALREADY_EXISTS')));

              case 13:
                _context.t0 = type.toLowerCase();
                _context.next = _context.t0 === 'rsa' ? 16 : 19;
                break;

              case 16:
                if (!(size < 2048)) {
                  _context.next = 18;
                  break;
                }

                return _context.abrupt("return", throwDelayed(errcode(new Error("Invalid RSA key size ".concat(size)), 'ERR_INVALID_KEY_SIZE')));

              case 18:
                return _context.abrupt("break", 20);

              case 19:
                return _context.abrupt("break", 20);

              case 20:
                _context.prev = 20;
                _context.next = 23;
                return crypto.keys.generateKeyPair(type, size);

              case 23:
                keypair = _context.sent;
                _context.next = 26;
                return keypair.id();

              case 26:
                kid = _context.sent;
                _context.next = 29;
                return keypair.export(this._());

              case 29:
                pem = _context.sent;
                keyInfo = {
                  name: name,
                  id: kid
                };
                batch = self.store.batch();
                batch.put(dsname, pem);
                batch.put(DsInfoName(name), JSON.stringify(keyInfo));
                _context.next = 36;
                return batch.commit();

              case 36:
                _context.next = 41;
                break;

              case 38:
                _context.prev = 38;
                _context.t1 = _context["catch"](20);
                return _context.abrupt("return", throwDelayed(_context.t1));

              case 41:
                return _context.abrupt("return", keyInfo);

              case 42:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[20, 38]]);
      }));

      function createKey(_x2, _x3, _x4) {
        return _createKey.apply(this, arguments);
      }

      return createKey;
    }()
    /**
     * List all the keys.
     *
      * @returns {KeyInfo[]}
     */

  }, {
    key: "listKeys",
    value: function () {
      var _listKeys = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var self, query, info, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, value;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                self = this;
                query = {
                  prefix: infoPrefix
                };
                info = [];
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _context2.prev = 5;
                _iterator = _asyncIterator(self.store.query(query));

              case 7:
                _context2.next = 9;
                return _iterator.next();

              case 9:
                _step = _context2.sent;
                _iteratorNormalCompletion = _step.done;
                _context2.next = 13;
                return _step.value;

              case 13:
                _value = _context2.sent;

                if (_iteratorNormalCompletion) {
                  _context2.next = 20;
                  break;
                }

                value = _value;
                info.push(JSON.parse(value.value));

              case 17:
                _iteratorNormalCompletion = true;
                _context2.next = 7;
                break;

              case 20:
                _context2.next = 26;
                break;

              case 22:
                _context2.prev = 22;
                _context2.t0 = _context2["catch"](5);
                _didIteratorError = true;
                _iteratorError = _context2.t0;

              case 26:
                _context2.prev = 26;
                _context2.prev = 27;

                if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                  _context2.next = 31;
                  break;
                }

                _context2.next = 31;
                return _iterator.return();

              case 31:
                _context2.prev = 31;

                if (!_didIteratorError) {
                  _context2.next = 34;
                  break;
                }

                throw _iteratorError;

              case 34:
                return _context2.finish(31);

              case 35:
                return _context2.finish(26);

              case 36:
                return _context2.abrupt("return", info);

              case 37:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[5, 22, 26, 36], [27,, 31, 35]]);
      }));

      function listKeys() {
        return _listKeys.apply(this, arguments);
      }

      return listKeys;
    }()
    /**
     * Find a key by it's id.
     *
     * @param {string} id - The universally unique key identifier.
      * @returns {KeyInfo}
     */

  }, {
    key: "findKeyById",
    value: function () {
      var _findKeyById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(id) {
        var keys;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return this.listKeys();

              case 3:
                keys = _context3.sent;
                return _context3.abrupt("return", keys.find(function (k) {
                  return k.id === id;
                }));

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3["catch"](0);
                return _context3.abrupt("return", throwDelayed(_context3.t0));

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 7]]);
      }));

      function findKeyById(_x5) {
        return _findKeyById.apply(this, arguments);
      }

      return findKeyById;
    }()
    /**
     * Find a key by it's name.
     *
     * @param {string} name - The local key name.
      * @returns {KeyInfo}
     */

  }, {
    key: "findKeyByName",
    value: function () {
      var _findKeyByName = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(name) {
        var dsname, res;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (validateKeyName(name)) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt("return", throwDelayed(errcode(new Error("Invalid key name '".concat(name, "'")), 'ERR_INVALID_KEY_NAME')));

              case 2:
                dsname = DsInfoName(name);
                _context4.prev = 3;
                _context4.next = 6;
                return this.store.get(dsname);

              case 6:
                res = _context4.sent;
                return _context4.abrupt("return", JSON.parse(res.toString()));

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4["catch"](3);
                return _context4.abrupt("return", throwDelayed(errcode(new Error("Key '".concat(name, "' does not exist. ").concat(_context4.t0.message)), 'ERR_KEY_NOT_FOUND')));

              case 13:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[3, 10]]);
      }));

      function findKeyByName(_x6) {
        return _findKeyByName.apply(this, arguments);
      }

      return findKeyByName;
    }()
    /**
     * Remove an existing key.
     *
     * @param {string} name - The local key name; must already exist.
      * @returns {KeyInfo}
     */

  }, {
    key: "removeKey",
    value: function () {
      var _removeKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(name) {
        var self, dsname, keyInfo, batch;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                self = this;

                if (!(!validateKeyName(name) || name === 'self')) {
                  _context5.next = 3;
                  break;
                }

                return _context5.abrupt("return", throwDelayed(errcode(new Error("Invalid key name '".concat(name, "'")), 'ERR_INVALID_KEY_NAME')));

              case 3:
                dsname = DsName(name);
                _context5.next = 6;
                return self.findKeyByName(name);

              case 6:
                keyInfo = _context5.sent;
                batch = self.store.batch();
                batch.delete(dsname);
                batch.delete(DsInfoName(name));
                _context5.next = 12;
                return batch.commit();

              case 12:
                return _context5.abrupt("return", keyInfo);

              case 13:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function removeKey(_x7) {
        return _removeKey.apply(this, arguments);
      }

      return removeKey;
    }()
    /**
     * Rename a key
     *
     * @param {string} oldName - The old local key name; must already exist.
     * @param {string} newName - The new local key name; must not already exist.
      * @returns {KeyInfo}
     */

  }, {
    key: "renameKey",
    value: function () {
      var _renameKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(oldName, newName) {
        var self, oldDsname, newDsname, oldInfoName, newInfoName, exists, res, pem, keyInfo, batch;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                self = this;

                if (!(!validateKeyName(oldName) || oldName === 'self')) {
                  _context6.next = 3;
                  break;
                }

                return _context6.abrupt("return", throwDelayed(errcode(new Error("Invalid old key name '".concat(oldName, "'")), 'ERR_OLD_KEY_NAME_INVALID')));

              case 3:
                if (!(!validateKeyName(newName) || newName === 'self')) {
                  _context6.next = 5;
                  break;
                }

                return _context6.abrupt("return", throwDelayed(errcode(new Error("Invalid new key name '".concat(newName, "'")), 'ERR_NEW_KEY_NAME_INVALID')));

              case 5:
                oldDsname = DsName(oldName);
                newDsname = DsName(newName);
                oldInfoName = DsInfoName(oldName);
                newInfoName = DsInfoName(newName);
                _context6.next = 11;
                return self.store.has(newDsname);

              case 11:
                exists = _context6.sent;

                if (!exists) {
                  _context6.next = 14;
                  break;
                }

                return _context6.abrupt("return", throwDelayed(errcode(new Error("Key '".concat(newName, "' already exists")), 'ERR_KEY_ALREADY_EXISTS')));

              case 14:
                _context6.prev = 14;
                _context6.next = 17;
                return this.store.get(oldDsname);

              case 17:
                res = _context6.sent;
                pem = res.toString();
                _context6.next = 21;
                return self.store.get(oldInfoName);

              case 21:
                res = _context6.sent;
                keyInfo = JSON.parse(res.toString());
                keyInfo.name = newName;
                batch = self.store.batch();
                batch.put(newDsname, pem);
                batch.put(newInfoName, JSON.stringify(keyInfo));
                batch.delete(oldDsname);
                batch.delete(oldInfoName);
                _context6.next = 31;
                return batch.commit();

              case 31:
                return _context6.abrupt("return", keyInfo);

              case 34:
                _context6.prev = 34;
                _context6.t0 = _context6["catch"](14);
                return _context6.abrupt("return", throwDelayed(_context6.t0));

              case 37:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[14, 34]]);
      }));

      function renameKey(_x8, _x9) {
        return _renameKey.apply(this, arguments);
      }

      return renameKey;
    }()
    /**
     * Export an existing key as a PEM encrypted PKCS #8 string
     *
     * @param {string} name - The local key name; must already exist.
     * @param {string} password - The password
      * @returns {string}
     */

  }, {
    key: "exportKey",
    value: function () {
      var _exportKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(name, password) {
        var dsname, res, pem, privateKey;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (validateKeyName(name)) {
                  _context7.next = 2;
                  break;
                }

                return _context7.abrupt("return", throwDelayed(errcode(new Error("Invalid key name '".concat(name, "'")), 'ERR_INVALID_KEY_NAME')));

              case 2:
                if (password) {
                  _context7.next = 4;
                  break;
                }

                return _context7.abrupt("return", throwDelayed(errcode(new Error('Password is required'), 'ERR_PASSWORD_REQUIRED')));

              case 4:
                dsname = DsName(name);
                _context7.prev = 5;
                _context7.next = 8;
                return this.store.get(dsname);

              case 8:
                res = _context7.sent;
                pem = res.toString();
                _context7.next = 12;
                return crypto.keys.import(pem, this._());

              case 12:
                privateKey = _context7.sent;
                return _context7.abrupt("return", privateKey.export(password));

              case 16:
                _context7.prev = 16;
                _context7.t0 = _context7["catch"](5);
                return _context7.abrupt("return", throwDelayed(_context7.t0));

              case 19:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[5, 16]]);
      }));

      function exportKey(_x10, _x11) {
        return _exportKey.apply(this, arguments);
      }

      return exportKey;
    }()
    /**
     * Import a new key from a PEM encoded PKCS #8 string
     *
     * @param {string} name - The local key name; must not already exist.
     * @param {string} pem - The PEM encoded PKCS #8 string
     * @param {string} password - The password.
      * @returns {KeyInfo}
     */

  }, {
    key: "importKey",
    value: function () {
      var _importKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(name, pem, password) {
        var self, dsname, exists, privateKey, kid, keyInfo, batch;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                self = this;

                if (!(!validateKeyName(name) || name === 'self')) {
                  _context8.next = 3;
                  break;
                }

                return _context8.abrupt("return", throwDelayed(errcode(new Error("Invalid key name '".concat(name, "'")), 'ERR_INVALID_KEY_NAME')));

              case 3:
                if (pem) {
                  _context8.next = 5;
                  break;
                }

                return _context8.abrupt("return", throwDelayed(errcode(new Error('PEM encoded key is required'), 'ERR_PEM_REQUIRED')));

              case 5:
                dsname = DsName(name);
                _context8.next = 8;
                return self.store.has(dsname);

              case 8:
                exists = _context8.sent;

                if (!exists) {
                  _context8.next = 11;
                  break;
                }

                return _context8.abrupt("return", throwDelayed(errcode(new Error("Key '".concat(name, "' already exists")), 'ERR_KEY_ALREADY_EXISTS')));

              case 11:
                _context8.prev = 11;
                _context8.next = 14;
                return crypto.keys.import(pem, password);

              case 14:
                privateKey = _context8.sent;
                _context8.next = 20;
                break;

              case 17:
                _context8.prev = 17;
                _context8.t0 = _context8["catch"](11);
                return _context8.abrupt("return", throwDelayed(errcode(new Error('Cannot read the key, most likely the password is wrong'), 'ERR_CANNOT_READ_KEY')));

              case 20:
                _context8.prev = 20;
                _context8.next = 23;
                return privateKey.id();

              case 23:
                kid = _context8.sent;
                _context8.next = 26;
                return privateKey.export(this._());

              case 26:
                pem = _context8.sent;
                _context8.next = 32;
                break;

              case 29:
                _context8.prev = 29;
                _context8.t1 = _context8["catch"](20);
                return _context8.abrupt("return", throwDelayed(_context8.t1));

              case 32:
                keyInfo = {
                  name: name,
                  id: kid
                };
                batch = self.store.batch();
                batch.put(dsname, pem);
                batch.put(DsInfoName(name), JSON.stringify(keyInfo));
                _context8.next = 38;
                return batch.commit();

              case 38:
                return _context8.abrupt("return", keyInfo);

              case 39:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[11, 17], [20, 29]]);
      }));

      function importKey(_x12, _x13, _x14) {
        return _importKey.apply(this, arguments);
      }

      return importKey;
    }()
  }, {
    key: "importPeer",
    value: function () {
      var _importPeer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(name, peer) {
        var self, privateKey, dsname, exists, kid, pem, keyInfo, batch;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                self = this;

                if (validateKeyName(name)) {
                  _context9.next = 3;
                  break;
                }

                return _context9.abrupt("return", throwDelayed(errcode(new Error("Invalid key name '".concat(name, "'")), 'ERR_INVALID_KEY_NAME')));

              case 3:
                if (!(!peer || !peer.privKey)) {
                  _context9.next = 5;
                  break;
                }

                return _context9.abrupt("return", throwDelayed(errcode(new Error('Peer.privKey is required'), 'ERR_MISSING_PRIVATE_KEY')));

              case 5:
                privateKey = peer.privKey;
                dsname = DsName(name);
                _context9.next = 9;
                return self.store.has(dsname);

              case 9:
                exists = _context9.sent;

                if (!exists) {
                  _context9.next = 12;
                  break;
                }

                return _context9.abrupt("return", throwDelayed(errcode(new Error("Key '".concat(name, "' already exists")), 'ERR_KEY_ALREADY_EXISTS')));

              case 12:
                _context9.prev = 12;
                _context9.next = 15;
                return privateKey.id();

              case 15:
                kid = _context9.sent;
                _context9.next = 18;
                return privateKey.export(this._());

              case 18:
                pem = _context9.sent;
                keyInfo = {
                  name: name,
                  id: kid
                };
                batch = self.store.batch();
                batch.put(dsname, pem);
                batch.put(DsInfoName(name), JSON.stringify(keyInfo));
                _context9.next = 25;
                return batch.commit();

              case 25:
                return _context9.abrupt("return", keyInfo);

              case 28:
                _context9.prev = 28;
                _context9.t0 = _context9["catch"](12);
                return _context9.abrupt("return", throwDelayed(_context9.t0));

              case 31:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this, [[12, 28]]);
      }));

      function importPeer(_x15, _x16) {
        return _importPeer.apply(this, arguments);
      }

      return importPeer;
    }()
    /**
     * Gets the private key as PEM encoded PKCS #8 string.
     *
     * @param {string} name
      * @returns {string}
     * @private
     */

  }, {
    key: "_getPrivateKey",
    value: function () {
      var _getPrivateKey2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(name) {
        var dsname, res;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (validateKeyName(name)) {
                  _context10.next = 2;
                  break;
                }

                return _context10.abrupt("return", throwDelayed(errcode(new Error("Invalid key name '".concat(name, "'")), 'ERR_INVALID_KEY_NAME')));

              case 2:
                _context10.prev = 2;
                dsname = DsName(name);
                _context10.next = 6;
                return this.store.get(dsname);

              case 6:
                res = _context10.sent;
                return _context10.abrupt("return", res.toString());

              case 10:
                _context10.prev = 10;
                _context10.t0 = _context10["catch"](2);
                return _context10.abrupt("return", throwDelayed(errcode(new Error("Key '".concat(name, "' does not exist. ").concat(_context10.t0.message)), 'ERR_KEY_NOT_FOUND')));

              case 13:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this, [[2, 10]]);
      }));

      function _getPrivateKey(_x17) {
        return _getPrivateKey2.apply(this, arguments);
      }

      return _getPrivateKey;
    }()
  }, {
    key: "cms",
    get: function get() {
      return new CMS(this);
    }
    /**
     * Generates the options for a keychain.  A random salt is produced.
     *
     * @returns {object}
     */

  }], [{
    key: "generateOptions",
    value: function generateOptions() {
      var options = Object.assign({}, defaultOptions);
      var saltLength = Math.ceil(NIST.minSaltLength / 3) * 3; // no base64 padding

      options.dek.salt = crypto.randomBytes(saltLength).toString('base64');
      return options;
    }
    /**
     * Gets an object that can encrypt/decrypt protected data.
     * The default options for a keychain.
     *
     * @returns {object}
     */

  }, {
    key: "options",
    get: function get() {
      return defaultOptions;
    }
  }]);

  return Keychain;
}();

module.exports = Keychain;